class PostSelection {
  constructor(product, defaultVariant, options = {}) {
    this.product = product;
    this.defaultVariant = defaultVariant;
    this.selectedVariant = this.defaultVariant;
    // Which modal this instance owns. ETConfigurator (FAT-299) passes its own so
    // both configurators can sit in the DOM during the A/B test.
    this.modalId = options.modalId || "modal-1";
    this.atcBtns = document.querySelectorAll(".post-selection__atc-btn");
    this.buyWithoutBtns = document.querySelectorAll(".post-selection__buy-without");
    this.checkoutBtn = document.querySelector(".post-selection__checkout-btn");
    this.infoContent = document.querySelector(".post-selection__info-content");
    this.itemsContainer = document.querySelector(".post-selection__items-container");
    this.variantOptions = document.querySelectorAll(".post-selection__variants-container input[type='radio']");
    this.variantOptionsCross = document.querySelectorAll(".post-selection__variants-cross input[type='radio']");
    this.upsellOptions = document.querySelectorAll(".post-selection__item input[type='checkbox']");
    this.overview = document.querySelector(".post-selection__overview");
    this.overviewList = document.querySelector(".post-selection__overview-list");
    this.overviewBtn = document.querySelector(".post-selection__overview-btn");
    this.insuranceInfoBtn = document.querySelector(".post-selection__insurance-info");
    this.infoBackBtn = document.querySelector(".post-selection__back-info");
    this.addAllBtn = document.querySelector("[data-add-all]");

    this._init();
    // Use the cart drawer/popover when the theme is set to one; only redirect to
    // /cart when cart_type is "page". Defaults to drawer behaviour if the global
    // isn't available yet (safe — production cart_type is "drawer").
    this.drawerShow = window.themeVariables?.settings?.cartType !== "page";
    this.drawerOpened = false;
  }

  _init() {
    this._microModal();
    this._splide();
    this._showAllContent();
    this._events();
    const mainItem = this._getSelectedVariant();
    if (mainItem) {
      this.selectedVariant = mainItem.id;
    }
    // const isMounted = mainItem.options.includes("Gemonteerd");
    // this._updateInsuranceShields(isMounted);

    // Evaluate insurance eligibility on load. The always-present free ART-4
    // gift satisfies the ART-only requirement, so insurance is an opt-in from
    // the start without needing a change event to fire first.
    this._checkInsuranceItems();
    this._checkCrossVariant();
  }


  _showAllContent() {
    document.querySelectorAll("[data-page]").forEach((item) => {
      item.style.display = "block";
    });

    document.querySelectorAll(".post-selection__items-category").forEach((category) => {
      category.style.display = "block";
    });

    document.querySelectorAll(".post-selection__cross-sale, .post-selection__services").forEach((section) => {
      section.style.display = "block";
    });

    const summary = document.querySelector(".post-selection__summary");
    if (summary) summary.style.display = "flex";

    const itemsContainer = document.querySelector(".post-selection__items-container");
    if (itemsContainer) itemsContainer.style.display = "flex";

    this._updateSingleStepButtons();
  }

  _updateSingleStepButtons() {
    // Hide navigation buttons (back, next)
    const backBtn = document.querySelector(".post-selection__back-btn");
    const nextBtn = document.querySelector(".post-selection__next-btn");
    const infoBackBtn = document.querySelector(".post-selection__back-info");

    if (backBtn) backBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
    if (infoBackBtn) infoBackBtn.style.display = "none";

    // Show close button and checkout button
    const shoppingBtn = document.querySelector(".post-selection__shopping-btn");
    if (shoppingBtn) shoppingBtn.style.display = "block";

    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "flex";
    }

    // Show overview
    if (this.overview) {
      this.overview.style.display = "block";
    }
  }

  _splide() {
    const el = document.querySelector(".splide");
    if (!el) return;

    new Splide(el, {
      type: "loop",
      perPage: 1,
      pagination: false,
      interval: 3000,
      speed: 800,
      autoplay: true,
      cover: false,
    }).mount();
  }

  _microModal() {
    this.microModalOptions = {
      openTrigger: "data-micromodal-open",
      closeTrigger: "data-micromodal-close",
      openClass: "is-open",
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      debugMode: false,
    };
    MicroModal.init(this.microModalOptions);

    const modal = document.getElementById(this.modalId) || document.querySelector(".modal");
    if (modal) {
      document.body.appendChild(modal);
    }
  }

  _events() {
    this.atcBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        this._handleATCBtn();
      })
    );

    this.buyWithoutBtns.forEach((btn) =>
      btn.addEventListener("click", () => {
        this._handleBuyWithoutBtn(btn);
      })
    );

    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener("click", () => {
        this._handleCheckoutBtn();
      });
    }

    this.upsellOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (input.dataset.cross === "false") {
          this._updatePrices();
          this._updateOverview();
          this._checkInsuranceItems();
          this._checkCrossVariant();
          this._checkServices(e);
        } else {
          this._checkUpsellBasedOnCross(input);
        }
      });
    });

    if (this.overviewList) {
      this.overviewList.addEventListener("click", (e) => {
        const closeBtn = e.target.closest(".post-selection__overview-item-close");
        if (closeBtn) {
          this._removeListItem(closeBtn.closest("li").dataset.variant);
        }
      });
    }

    if (this.overviewBtn) {
      this.overviewBtn.addEventListener("click", (e) => {
        this.overviewBtn.classList.toggle("active");
      });
    }

    if (this.insuranceInfoBtn) {
      this.insuranceInfoBtn.addEventListener("click", (e) => {
        this._showInsuranceInfo();
      });
    }

    if (this.infoBackBtn) {
      this.infoBackBtn.addEventListener("click", (e) => {
        this._hideInsuranceInfo();
      });
    }

    this.variantOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        let previousVariant = this.selectedVariant;

        this.selectedVariant = this._getSelectedVariant().id;
        this._updateURL();
        this._updatePrices();
        this._updateSelectedVariantText(e);
        this._updateOverview();
        this._updateInsuranceNote(e);
        this._checkInsuranceItems();
        this._updateDelivery();
        this._updateCrossVariants(e);
        this._checkCrossVariant();
      });
    });

    this.variantOptionsCross.forEach((input) => {
      input.addEventListener("change", (e) => {
        const selectedValue = e.target.value.replace("-cross", "");
        const optionToClick = [...this.variantOptions]
          .filter((input) => input.value === selectedValue)
          .pop();

        optionToClick.click();
      });
    });

    if (this.addAllBtn) {
      this.addAllBtn.addEventListener("click", (e) => {
        this._handleAddAllBtn();
      });
    }
  }

  _isElementVisible(element) {
    if (!element) return false;

    const computedStyle = window.getComputedStyle(element);
    return computedStyle.display !== 'none' &&
      computedStyle.visibility !== 'hidden' &&
      element.offsetParent !== null;
  }

  _handleAddAllBtn() {
    const allItems = document.querySelectorAll(".post-selection__cross-sale .post-selection__item input[type='checkbox']");
    const visibleItems = Array.from(allItems).filter(item => {
      const itemElement = item.closest('.post-selection__item');
      return this._isElementVisible(itemElement);
    });

    visibleItems.forEach((item) => {
      item.click();
    });
    document.querySelector('.post-selection__items-category[data-insurance="true"] input') ? document.querySelector('.post-selection__items-category[data-insurance="true"] input').click() : false;
  }

  _showInsuranceInfo() {
    // Hide main content and show insurance info
    document.querySelector(".post-selection__summary").style.display = "none";
    document.querySelector(".post-selection__items-container").style.display = "none";
    document.querySelector(".post-selection__variants-container").style.display = "none";

    // Show insurance info section
    const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
    if (insuranceInfo) {
      insuranceInfo.style.display = "block";
    }

    // Show back button
    if (this.infoBackBtn) {
      this.infoBackBtn.style.display = "flex";
    }

    // Hide checkout button temporarily
    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "none";
    }
  }

  _hideInsuranceInfo() {
    // Show main content again
    document.querySelector(".post-selection__summary").style.display = "flex";
    document.querySelector(".post-selection__items-container").style.display = "flex";
    document.querySelector(".post-selection__variants-container").style.display = "block";

    // Hide insurance info section
    const insuranceInfo = document.querySelector(".post-selection__insurance-info-section");
    if (insuranceInfo) {
      insuranceInfo.style.display = "none";
    }

    // Hide back button
    if (this.infoBackBtn) {
      this.infoBackBtn.style.display = "none";
    }

    // Show checkout button again
    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "flex";
    }
  }

  _checkUpsellBasedOnCross(input) {
    const targetValue = input.id.replace("variant-", "").replace("-cross", "");
    const targetUpsell = document.querySelector(
      `.post-selection__item input[value='${targetValue}']`
    );
    if (targetUpsell) {
      input.checked = false;
      targetUpsell.click();
    }
  }

  _checkServices(e) {
    const item = e.target.closest(".post-selection__item");
    const isService = item.dataset.service === "true";
    if (isService) {
      const selectedService = e.target.value;
      const serviceItems = document.querySelectorAll(
        '.post-selection__item[data-service="true"] input[type="checkbox"]'
      );

      serviceItems.forEach((serviceItem) => {
        if (serviceItem !== e.target) {
          serviceItem.checked = false;
        }
      });

      this._updateOverview();
      this._updatePrices();
    }
  }

  _checkCrossVariant() {
    const selectedUpsells = this._getUpsellItems();
    const mainItem = this._getSelectedVariant();

    // const isMounted = mainItem.options.includes("Gemonteerd");
    const isArtLock = selectedUpsells.some((item) => item.artLock);
    const isLoqater = selectedUpsells.some((item) =>
      item.title.toLowerCase().includes("loqater")
    );

    const crossSaleSection = document.querySelector(".post-selection__cross-sale");
    if (crossSaleSection) {
      // ART-only easy-logic: the cross-sale ("add a lock to qualify") is only
      // relevant when no ART lock is present. The free ART-4 gift already
      // qualifies the bike, so this section stays hidden in practice.
      crossSaleSection.style.display = isArtLock ? "none" : "flex";

      const displayStyle = (condition) => (condition ? "none" : "block");
      const optionElement = crossSaleSection.querySelector(".post-selection__option");
      //   if (optionElement) {
      //     optionElement.style.display = displayStyle(isMounted);
      //   }

      const lockItem = crossSaleSection.querySelector(".post-selection__item input[name='categorie_sloten']");
      if (lockItem) {
        lockItem.closest(".post-selection__item").style.display = displayStyle(isArtLock);
      }

      const gpsItem = crossSaleSection.querySelector(".post-selection__item input[name='categorie_gps']");
      if (gpsItem) {
        gpsItem.closest(".post-selection__item").style.display = displayStyle(isLoqater);
      }
    }
  }

  _updateCrossVariants(e) {
    const selectedCrossOption = [...this.variantOptionsCross].find(
      (input) => input.value === `${e.target.value}-cross`
    );
    if (selectedCrossOption) {
      selectedCrossOption.click();
    }
  }

  _updateDelivery() {
    const variantInventory = document.querySelector(
      ".post-selection__inventory variant-inventory"
    );

    if (variantInventory) {
      const variants = variantInventory.querySelectorAll("[data-variant-id]");

      variants.forEach((variant) => {
        variant.setAttribute("hidden", "");
      });
      variants.forEach((variant) => {
        if (+variant.dataset.variantId === this.selectedVariant) {
          variant.removeAttribute("hidden");
        }
      });
    }
  }

  // Read the current variant from the PDP option radio inputs (same method as
  // et-pricing-display) and store it on this.selectedVariant.
  _syncSelectedVariantFromPDP() {
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      const formId = variantPicker.getAttribute('form-id');
      if (formId) {
        const checkedInputs = document.querySelectorAll(
          'input[data-option-position][form="' + formId + '"]:checked'
        );
        if (checkedInputs.length > 0) {
          const matchedVariant = this.product.variants.find((v) =>
            Array.from(checkedInputs).every((input) => {
              const pos = input.getAttribute('data-option-position');
              return v['option' + pos] === input.value;
            })
          );
          if (matchedVariant) {
            this.selectedVariant = matchedVariant.id;
          }
        }
      }
    }
  }

  _handleATCBtn() {
    this._syncSelectedVariantFromPDP();
    this._updatePrices();
    this._updateOverview();
    MicroModal.show(this.modalId, this.microModalOptions);
  }

  // "Ohne Zubehör kaufen" (DE): add just the bare bike to the cart, skipping the
  // configurator. Reuses _addVariantsToCart so the same cart/add + variant:add
  // events fire — Elevar add_to_cart tracking is identical to the checkout path.
  // The in-flight guard prevents double-adds from rapid clicks.
  _handleBuyWithoutBtn(btn) {
    if (this._buyWithoutInFlight) return;
    this._buyWithoutInFlight = true;
    if (btn) btn.setAttribute("aria-busy", "true");

    this._syncSelectedVariantFromPDP();
    this._addVariantsToCart([this._withDeliveryTime({ id: this.selectedVariant, quantity: 1 })], () => {
      this._buyWithoutInFlight = false;
      if (btn) btn.removeAttribute("aria-busy");
    });
  }

  _handleCheckoutBtn() {
    this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner").style.display = "none";
    this.checkoutBtn.querySelector(".post-selection__btn-loader").style.display = "flex";

    // Add the bike AND all upsells in ONE cart/add call so the drawer opens once.
    // The insurance line carries a stable `Activatie` property (see _getUpsellPayload):
    // without it the gift app treats the €0 "Verzekeringsaanvraag" as a managed gift and
    // re-syncs it with a delayed refresh that CLOSES the drawer. The property gives the
    // line a stable identity the app leaves alone → the drawer stays open.
    const items = [
      this._withDeliveryTime({ id: this.selectedVariant, quantity: 1 }),
      ...this._getUpsellPayload(),
    ];

    this._addVariantsToCart(items, () => {
      this.drawerShow ? false : (window.location.href = "/cart");
    });
  }

  // Build the upsell line-item payload (does NOT add to cart): the insurance line gets
  // a stable `Activatie` property, value-0/included gift items are dropped, and duplicate
  // variant ids are de-duped.
  _getUpsellPayload() {
    const insuranceInput = this._getInsuranceInput();
    const insuranceId = insuranceInput ? +insuranceInput.value : null;
    // CONSTANT note = stable cart-line merge key. Insurance is NL-only, so this NL
    // string is fine; it must NOT vary per render or the line splits into separate lines.
    const INSURANCE_NOTE = "Je ontvangt na bezorging een activatielink";

    return this._getUpsellItems()
      .map((item) => {
        const payload = { id: item.id, quantity: item.quantity };
        if (insuranceId && item.id === insuranceId) {
          payload.properties = { Activatie: INSURANCE_NOTE };
        }
        return this._withDeliveryTime(payload, item.deliveryTime);
      })
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        if (!acc.some((i) => i.id === item.id)) acc.push(item);
        return acc;
      }, []);
  }

  // FAT-327 — stamp the market's delivery message onto a line so it reaches the order (and
  // Klaviyo) as `_delivery_time`. Upsells carry theirs on the checkbox (data-delivery-time); the
  // bike is looked up in the variant map rendered by et-delivery-line-property. Like every other
  // property here the value is deterministic per render, so lines still merge; a variant without
  // a delivery metafield gets no property at all.
  _withDeliveryTime(payload, deliveryTime) {
    const value =
      deliveryTime || (window.ETDeliveryTimes ? window.ETDeliveryTimes.get(payload.id) : "");

    if (!value) return payload;

    payload.properties = Object.assign({}, payload.properties, { _delivery_time: value });
    return payload;
  }

  _getInsuranceInput() {
    const cat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
    return cat ? cat.querySelector('input[name="categorie_verzekering"]') : null;
  }

  _getSelectedVariant() {
    const selectedOptions = [];
    const selected = document.querySelectorAll(
      ".post-selection__variants-container input[type='radio']:checked"
    );

    selected.forEach((input) => {
      const optionValue = input.value;
      selectedOptions.push(optionValue);
    });

    const matchedVariant = this.product.variants.find((variant) =>
      selectedOptions.every((optionValue) =>
        variant.options.includes(optionValue)
      )
    );

    return matchedVariant;
  }

  _getUpsellItems() {
    const items = document.querySelectorAll(
      '.post-selection__items-container input[type="checkbox"]:checked'
    );

    const itemsArray = Array.from(items).filter(
      (item) => item.dataset.cross === "false"
    );

    const itemsToAdd = itemsArray.map((item) => {
      return {
        id: +item.value,
        quantity: 1,
        title: item.dataset.title,
        img: item.dataset.img,
        price: item.dataset.price,
        artLock: item.dataset.artLock === "true",
        deliveryTime: item.dataset.deliveryTime || "",
      };
    });

    return itemsToAdd;
  }

  _updateHeaderCounter() {
    fetch(window.Shopify.routes.root + "?sections=header")
      .then((res) => res.json())
      .then((htmlString) => {
        const parser = new DOMParser();
        const header = parser.parseFromString(htmlString.header, "text/html");
        const cartCount = header.querySelector(".header__cart-count");
        document.querySelector(".header__cart-count").replaceWith(cartCount);
      });
  }

  _updateSelectedVariantText(e) {
    const selectedValue = e.target.value;
    const selectedOption = e.target
      .closest(".post-selection__option")
      .querySelector(".post-selection__selected-option");
    if (selectedOption) {
      selectedOption.textContent = selectedValue;
    }
  }

  _updatePrices() {
    const matchedVariant = this.product.variants.find(
      (variant) => variant.id === this.selectedVariant
    );

    const comparePrice = document.querySelector(".post-selection__compare-price");
    const totalPrice = document.querySelector(".post-selection__total-price");
    const upsellItems = this._getUpsellItems();
    const totalUpsellPrice = upsellItems
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        const idExists = acc.some((i) => i.id === item.id);
        if (!idExists) {
          acc.push(item);
        }
        return acc;
      }, [])
      .reduce((acc, item) => {
        return acc + +item.price;
      }, 0);

    if (comparePrice) {
      comparePrice.textContent = this._formatPrice(
        matchedVariant.compare_at_price + totalUpsellPrice
      );
    }
    if (totalPrice) {
      totalPrice.textContent = this._formatPrice(
        matchedVariant.price + totalUpsellPrice
      );
    }
    const installmentPrice = document.querySelector(".post-selection__footer .klarna-in3-price");
    if (installmentPrice) {
      installmentPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) / 3).toFixed(0));
    }
    const spraypayPrice = document.querySelector(".post-selection__footer .spraypay-price");
    if (spraypayPrice) {
      spraypayPrice.textContent = this._formatPrice(((matchedVariant.price + totalUpsellPrice) * 0.02327).toFixed(0));
    }
  }

  _updateOverview() {
    if (!this.overviewList) return;

    this.overviewList.innerHTML = "";

    const selectedVariant = this.product.variants.find(
      (variant) => variant.id === this.selectedVariant
    );

    // Add main variant
    this._addItemToList(
      this.product.title,
      this._formatPrice(selectedVariant.price),
      this.product.featured_image,
      this.selectedVariant
    );

    // Add upsells
    const upsellItems = this._getUpsellItems()
      .filter((item) => item.id !== 0)
      .reduce((acc, item) => {
        const idExists = acc.some((i) => i.id === item.id);
        if (!idExists) {
          acc.push(item);
        }
        return acc;
      }, []);

    upsellItems.forEach((upsell) => {
      this._addItemToList(
        upsell.title,
        this._formatPrice(upsell.price),
        upsell.img,
        upsell.id
      );
    });
  }

  _updateInsuranceNote(e) {
    const insuranceNote = e.target
      .closest(".post-selection__option")
      .querySelector(".post-selection__insurance-note");

    if (insuranceNote) {
      const insuranceDeny = insuranceNote.querySelector(".post-selection__insurance-deny");
      const insuranceApprove = insuranceNote.querySelector(".post-selection__insurance-approve");

      if (e.target.value === "Gemonteerd") {
        if (insuranceDeny) insuranceDeny.style.display = "none";
        if (insuranceApprove) insuranceApprove.style.display = "flex";
        this._updateInsuranceShields(true);
      } else {
        if (insuranceDeny) insuranceDeny.style.display = "none";
        if (insuranceApprove) insuranceApprove.style.display = "flex";
        this._updateInsuranceShields(true);
      }
    }
  }

  _updateInsuranceShields(show) {
    const productShields = document.querySelectorAll(".post-selection__item-product-shield");
    productShields.forEach((shield) => {
      shield.style.display = show ? "inline-flex" : "none";
    });
  }

  _checkInsuranceItems() {
    const insuranceCat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
    const insuranceNote = document.querySelector(".post-selection__insurance-note--final");

    if (!insuranceCat || !insuranceNote) return;

    const mainItem = this._getSelectedVariant();
    const upsellItems = this._getUpsellItems();
    // ART-only easy-logic: an ART lock alone (e.g. the always-present free
    // ART-4 gift) makes the bike eligible for insurance. Loqater GPS is no
    // longer required. Eligibility keys off the handle-derived data-art-lock
    // flag (not the human-facing title), so it can't false-match on substrings.
    const isArtLock = upsellItems.some((item) => item.artLock);

    if (isArtLock) {
      insuranceCat.classList.remove("disabled");
      insuranceCat.querySelectorAll("input").forEach((input) => {
        input.disabled = false;
        input.removeAttribute("disabled");
      });

      const denyElement = insuranceNote.querySelector(".post-selection__insurance-deny");
      const approveElement = insuranceNote.querySelector(".post-selection__insurance-approve");

      if (denyElement) denyElement.style.display = "none";
      if (approveElement) approveElement.style.display = "flex";
    } else {
      insuranceCat.classList.add("disabled");
      insuranceCat.querySelectorAll("input").forEach((input) => {
        input.disabled = true;
        input.setAttribute("disabled", "");
        input.checked = false;
      });

      const denyElement = insuranceNote.querySelector(".post-selection__insurance-deny");
      const approveElement = insuranceNote.querySelector(".post-selection__insurance-approve");

      if (denyElement) denyElement.style.display = "flex";
      if (approveElement) approveElement.style.display = "none";

      this._updateOverview();
      this._updatePrices();
    }

    this._toggleInsuranceExtras();
  }

  _toggleInsuranceExtras() {
    // Reveal the postcode calculator + eligibility note only once the shopper
    // opts into insurance (clicks the insurance card). CSS keeps them hidden
    // until the category carries the `insurance-active` class.
    const insuranceCat = document.querySelector('.post-selection__items-category[data-insurance="true"]');
    if (!insuranceCat) return;
    const insuranceInput = insuranceCat.querySelector('input[name="categorie_verzekering"]');
    const active = !!(insuranceInput && insuranceInput.checked);
    insuranceCat.classList.toggle("insurance-active", active);
  }

  _createListItem(title, price, imgSrc, variantId) {
    const template = document.getElementById("listItemTemplate");
    if (!template) return null;

    const clone = template.content.cloneNode(true);

    const titleElement = clone.querySelector(".post-selection__item-product-title");
    const priceElement = clone.querySelector(".post-selection__item-product-price");
    const imgElement = clone.querySelector(".post-selection__overview-img");
    const itemElement = clone.querySelector(".post-selection__overview-item");

    if (titleElement) titleElement.textContent = title;
    if (priceElement) priceElement.textContent = price;
    if (imgElement) imgElement.src = imgSrc;
    if (itemElement) itemElement.setAttribute("data-variant", variantId);

    return clone;
  }

  _addItemToList(title, price, imgSrc, variantId) {
    if (!this.overviewList) return;

    this.overviewList.style.display = "flex";
    const listItem = this._createListItem(title, price, imgSrc, variantId);
    if (listItem) {
      this.overviewList.appendChild(listItem);
    }
  }

  _removeListItem(variantId) {
    if (!this.overviewList) return;

    const listItem = this.overviewList.querySelector(
      `.post-selection__overview-item[data-variant='${variantId}']`
    );
    if (listItem) {
      listItem.remove();
    }

    const checkBoxes = document.querySelectorAll(`input#variant-${variantId}`);
    checkBoxes.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });

    const checkBoxesCross = document.querySelectorAll(`input#variant-${variantId}-cross`);
    checkBoxesCross.forEach((checkBox) => {
      if (checkBox) {
        checkBox.checked = false;
      }
    });

    if (this.overviewList.children.length === 0) {
      this.overviewList.style.display = "none";
    }

    this._updatePrices();
    this._checkInsuranceItems();
    this._checkCrossVariant();
  }

  // FAT-300: both delegate to the shared formatter (assets/et-money.js), which is also what
  // snippets/format-price.liquid renders server-side. This replaced a private copy of Shopify's
  // money-format parser that read window.themeVariables.settings.moneyFormat and therefore
  // produced a different result on every non-euro market.
  _formatPrice(priceInCents) {
    return window.etMoney(priceInCents);
  }

  formatMoney(cents) {
    return window.etMoney(cents);
  }

  _updateURL() {
    const url = new URLParse(window.location.href, true);
    const newVariantValue = this.selectedVariant;
    url.query.variant = newVariantValue;
    window.history.replaceState(null, null, url.toString());
  }

  _getCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((response) => response.json());
  }

  _addVariantsToCart(items, cb = null) {
    const cartDrawerEl = document.querySelector("cart-drawer");
    const drawerId = cartDrawerEl
      ? cartDrawerEl.parentElement.id.replace("shopify-section-", "")
      : null;

    items.length > 0 ? (this.drawerOpened = true) : (this.drawerOpened = false);

    let formData = {
      items: items,
    };

    if (drawerId) {
      formData.sections = `variant-added,${drawerId}`;
    }
    if (items.length > 0) {
      // FAT-314: must carry the locale root. Without it the Section Rendering API renders the
      // bundled cart-drawer sections in the market's PRIMARY language, so adding to cart on
      // gofatbike.ch/fr returned a German drawer on a French page.
      formData.sections_url = `${window.Shopify.routes.root}variants/${items[0].id}`;
    }

    if (this.drawerShow) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: ["variant-added"] },
        })
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(`Cart add failed (${response.status}): ${text}`);
          });
        }
        return response.json();
      })
      .then((responseJson) => {
        this.drawerShow && this.drawerOpened
          ? this._openDrawer(responseJson)
          : false;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
        this.drawerShow ? this._closeModal() : false;
      });
  }

  async _openDrawer(responseJson) {
    // Fetch the fresh cart for the drawer content, but never let a failed
    // /cart.js block the open: the cart-drawer's variant:add listener only
    // needs the event to fire to call show().
    let cartContent;
    try {
      cartContent = await (await fetch(`/cart.js`)).json();
    } catch (e) {
      cartContent = {};
    }
    cartContent["sections"] = responseJson["sections"];
    document.documentElement.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items")
            ? responseJson["items"]
            : [responseJson],
          cart: cartContent,
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      })
    );
  }

  _closeModal() {
    const closeBtn = document.querySelector(".micromodal-slide [data-micromodal-close]");
    if (closeBtn) closeBtn.click();
    if (this.checkoutBtn) {
      const inner = this.checkoutBtn.querySelector(".post-selection__checkout-btn-inner");
      const loader = this.checkoutBtn.querySelector(".post-selection__btn-loader");
      if (inner) inner.style.display = "flex";
      if (loader) loader.style.display = "none";
    }
  }

  _removeVariantsFromCart(variantToRemove, cb = null) {
    let updates = {
      [variantToRemove]: 0,
    };
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (cb) {
          cb();
        }
      });
  }
}